/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the winner pool relates to entry fees. FIXED (default) — the pool is the announced guaranteedPoolUsd regardless of how many enter; entry fees are platform revenue. ENTRY_SCALED — the pool is entry fees net of the platform fee, with guaranteedPoolUsd as a floor.
 * @export
 */
export const PrizePoolMode = {
    FIXED: 'FIXED',
    ENTRY_SCALED: 'ENTRY_SCALED'
} as const;
export type PrizePoolMode = typeof PrizePoolMode[keyof typeof PrizePoolMode];


export function instanceOfPrizePoolMode(value: any): boolean {
    for (const key in PrizePoolMode) {
        if (Object.prototype.hasOwnProperty.call(PrizePoolMode, key)) {
            if (PrizePoolMode[key as keyof typeof PrizePoolMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PrizePoolModeFromJSON(json: any): PrizePoolMode {
    return PrizePoolModeFromJSONTyped(json, false);
}

export function PrizePoolModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizePoolMode {
    return json as PrizePoolMode;
}

export function PrizePoolModeToJSON(value?: PrizePoolMode | null): any {
    return value as any;
}

export function PrizePoolModeToJSONTyped(value: any, ignoreDiscriminator: boolean): PrizePoolMode {
    return value as PrizePoolMode;
}

